import { EFrequency } from "src/app/domain/enum/frequency";
import { EStrategyStatus } from "src/app/domain/enum/strategy-status";
import { ESubSectionType } from "src/app/domain/enum/sub-section-type";
import { ETimeSlot } from "src/app/domain/enum/time-slot";
import { EZoneUsage } from "src/app/domain/enum/zone-usage";
import { EExoticMeasure } from "src/app/domain/exotic-measure-type";
import { EStrategyType } from "src/app/domain/strategy-type";

export class StringConverter {

    static getConfirmMessageByLabel(label: string) {
        switch (label) {
            case 'confirm-removal-generic':
                return 'Etes-vous sûr de vouloir supprimer cet élément ?';
            case 'confirm-removal-strategy':
                return 'Etes-vous sûr de vouloir supprimer cette stratégie ?';
            default:
                return 'Not Set';
        }
    }

    static getFrequencyName(freq: EFrequency) {
        switch (freq) {
            case EFrequency.Day:
                return 'Jours';
            case EFrequency.Week:
                return 'Semaines';
            case EFrequency.Month:
                return 'Mois';
            case EFrequency.Year:
                return 'Années';
            default:
                return 'Not Set';
        }
    }

    static getFDXFrequencyName(freq: EFrequency) {
        switch (freq) {
            case EFrequency.Day:
                return 'Jours';
            case EFrequency.Week:
                return 'Hebdomadaire (6-7)';
            case EFrequency.Month:
                return 'Mois';
            case EFrequency.Year:
                return 'Années';
            case EFrequency.Biweekly:
                return 'Bihebdomadaire (8-9)'
            case EFrequency.BiMonthly:
                return 'Bimensuel (4-5)'
            default:
                return 'Not Set';
        }
    }

    static getNotificationMessageByLabel(label: string) {
        switch (label) {
            case 'zone-update-errors':
                return 'Des erreurs sont présentes dans les données.';
            case 'zone-measure-reference-errors':
                return 'Il n\'est pas possible d\'avoir plusieurs mesures avec la même référence GA X';
            case 'zone-no-maps-available':
                return 'Aucun plan disponible';
            case 'work-measurements-mpca-name-already-exists':
                return 'Ce nom de MPCA exite déjà.';
            case 'work-measurements-save-success':
                return 'Informations sauvegardées.';
            case 'work-measurements-validation-error':
                return 'Des erreurs sont présentes dans les données.';
            case 'work-measurements-naming-error':
                return 'Les MPCA clients ne peuvent avoir 2 fois le même nom.';
            case 'zone-creation-success':
                return 'Zone créée.';
            case 'zone-update-success':
                return 'Zone mise à jour.';
            case 'zone-removal-success':
                return 'Zone supprimée.';
            case 'zones-reorder-success':
                return 'Les zones ont été renommées.';
            case 'portfolio-update-success':
                return 'Dossier mis à jour.';
            case 'zone-no-zone-can-be-configured':
                return 'Cette stratégie ne permet pas l\'ajout de zone.';
            case 'form-invalid':
                return 'Des erreurs sont présentes dans les données.';
            case 'process-creation-success':
                return 'Processus créé';
            default:
                return 'Not Set';
        }
    }

    static getStrategyTypeName(type: EStrategyType): string {
        switch (type) {
            case EStrategyType.LaborLaw:
                return 'Code du travail';
            case EStrategyType.PublicHealthLaw:
                return 'Code de la santé publique';
            default:
                return 'Not Set';
        }
    }

    static getExoticMeasure(type: EExoticMeasure): string {
        switch (type) {
            case EExoticMeasure.AdductionAir:
                return 'Adduction d\'air';
            case EExoticMeasure.Lingette:
                return 'Lingette';
            case EExoticMeasure.Eau:
                return 'Eau';
            case EExoticMeasure.Massif:
                return 'Massif';
            default:
                return 'Not Set';
        }
    }

    static getTimeSlotName(type: ETimeSlot): string {
        switch (type) {
            case ETimeSlot.Morning:
                return 'Matin';
            case ETimeSlot.Afternoon:
                return 'Après-midi';
            case ETimeSlot.None:
                return 'Indifférent'
            default:
                return 'Not Set';
        }
    }

    static getStrategyStatusName(status: EStrategyStatus) {
        switch (status) {
            case EStrategyStatus.New:
                return 'Rédaction en cours';
            case EStrategyStatus.WorkMeasurementMPCA:
                return 'Rédaction en cours';
            case EStrategyStatus.ZoneProcess:
                return 'Rédaction en cours';
            case EStrategyStatus.Proposal:
                return 'Stratégie disponible';
            case EStrategyStatus.WorkInProgress:
                return 'Chantier en cours';
            case EStrategyStatus.FinalReportTBD:
                return 'Chantier en cours';
            case EStrategyStatus.FinalReport:
                return 'Chantier terminé'; // Rapport final disponible
            case EStrategyStatus.Ordered:
                return 'Demande envoyée';
            default:
                return 'Not Set';
        }
    }

    static getSubSectionTypeName(status: ESubSectionType) {
        switch (status) {

            case ESubSectionType.SubSection3:
                return 'Sous-section 3'
            case ESubSectionType.SubSection4:
                return 'Sous-section 4'
            case ESubSectionType.SubSection3_4:
                return 'Sous-section 3 & 4'
            default:
                return 'Not Set';
        }
    }

    static getZoneUsageName(zoneUsage: EZoneUsage) {
        switch (zoneUsage) {
            case EZoneUsage.PreWork:
                return 'Avant travaux';
            case EZoneUsage.Environmental:
                return 'Pendant travaux';
            case EZoneUsage.PostWork:
                return 'Après travaux';
            default:
                return 'Not Set';
        }
    }

    static getMonthName(month: number) {
        switch (month) {

            case 1:
                return 'Janvier'
            case 2:
                return 'Février'
            case 3:
                return 'Mars'
            case 4:
                return 'Avril'
            case 5:
                return 'Mai'
            case 6:
                return 'Juin'
            case 7:
                return 'Juillet'
            case 8:
                return 'Août'
            case 9:
                return 'Septembre'
            case 10:
                return 'Octobre'
            case 11:
                return 'Novembre'
            case 12:
                return 'Décembre'
        }
    }
}
